import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { grupoClassificacaoSituacaoCadastroCliente, grupoClassificacaoSituacaoCadastroItem, grupoClassificacaoSituacaoAtivo, grupoClassificacaoSituacaoInativo } from '../grupo-classificacao-situacao';

@Component({
    selector: 'sgt-grupo-classificacao-situacao-multiselect',
    templateUrl: './grupo-classificacao-situacao-multiselect.component.html',
    styleUrls: ['./grupo-classificacao-situacao-multiselect.component.less']
})
export class GrupoClassificacaoSituacaoMultiselectComponent implements OnInit {
    /** Situações selecionadas */
    @Input() situacoes: number[];
    /** Ao alterar a seleção das situações */
    @Output() situacoesChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Situação';
    @Input() checked = 'Situação'
    @Input() checkedPlural = 'Situações';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma situação encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowCadastroCliente = true;
    @Input() isShowCadastroItem = true;
    @Input() isShowAtivo = true;
    @Input() isShowInativo = true;
    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-grupo-classificacao-situacao ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as situações para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        if (this.isShowCadastroCliente) {
            selects.push({
                id: grupoClassificacaoSituacaoCadastroCliente.id,
                name: grupoClassificacaoSituacaoCadastroCliente.nome,
                classes: 'multiselect-item-grupo-classificacao-situacao multiselect-item-grupo-classificacao-situacao-cadastro-cliente'
            });
        }
        if (this.isShowCadastroItem) {
            selects.push({
                id: grupoClassificacaoSituacaoCadastroItem.id,
                name: grupoClassificacaoSituacaoCadastroItem.nome,
                classes: 'multiselect-item-grupo-classificacao-situacao multiselect-item-grupo-classificacao-situacao-cadastro-item'
            });
        }
        if (this.isShowAtivo) {
            selects.push({
                id: grupoClassificacaoSituacaoAtivo.id,
                name: grupoClassificacaoSituacaoAtivo.nome,
                classes: 'multiselect-item-grupo-classificacao-situacao multiselect-item-grupo-classificacao-situacao-ativo'
            });
        }
        if (this.isShowInativo) {
            selects.push({
                id: grupoClassificacaoSituacaoInativo.id,
                name: grupoClassificacaoSituacaoInativo.nome,
                classes: 'multiselect-item-grupo-classificacao-situacao multiselect-item-grupo-classificacao-situacao-inativo'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção das situações */
    onChange() {
        this.situacoesChange.emit(this.situacoes);
    }
}
